import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Button, message } from 'antd';

const SimpleCreateModal = ({ visible, setVisible, title, inputLabel, createFn, onCreated, initialName = '' }) => {
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (visible) setName(initialName);
  }, [visible, initialName]);

  const handleCreate = async () => {
    if (!name.trim()) return;
    setCreating(true);
    try {
      const response = await createFn({ name: name.trim() });
      if (response && response.id) {
        onCreated(response);
        setVisible(false);
        message.success('Creado exitosamente');
      }
    } catch (error) {
      console.error(error);
      message.error('Error al crear');
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal
      className="creation-modal"
      title={null}
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <h1 className="mb-20 mt-20 text-center">{title}</h1>
      <Form layout="vertical">
        <Form.Item label={inputLabel} required>
          <Input 
            placeholder={`Ingrese ${inputLabel.toLowerCase()}`} 
            value={name} 
            onChange={e => setName(e.target.value)} 
            className="cmt-input"
          />
        </Form.Item>
        <Row gutter={16} justify="center" className="mt-20">
          <Col span={10}>
            <Button block className="cmt-button primary outline" type="primary" onClick={() => setVisible(false)}>
              Cancelar
            </Button>
          </Col>
          <Col span={10}>
            <Button block type="primary" className="cmt-button primary" onClick={handleCreate} loading={creating}>
              Crear
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default SimpleCreateModal;
